import { useQuery } from '@tanstack/react-query';
import api from '../services/authService';

/**
 * Hook to fetch admin vendors list
 */
export const useAdminVendors = (params = {}, options = {}) => {
  return useQuery({
    queryKey: ['adminVendors', params],
    queryFn: async () => {
      const response = await api.get('/admin/vendors', { params });
      return response.data;
    },
    ...options
  });
};

/**
 * Hook to fetch a single admin vendor by ID
 */
export const useAdminVendor = (vendorId, options = {}) => {
  return useQuery({
    queryKey: ['adminVendor', vendorId],
    queryFn: async () => {
      if (!vendorId) return null;
      const response = await api.get(`/admin/vendors/${vendorId}`);
      return response.data;
    },
    enabled: !!vendorId && (options.enabled !== false),
    ...options
  });
};

